import DivitAPI from '@/services/api'

export const fetchProfile = () => async (dispatch) => {
  const { data } = await DivitAPI.get('users/v2/profiles')
  dispatch({ type: 'profile/getProfileSuccess', payload: data.data })
}

export default 0
